import { useEffect, useRef } from 'react'

import { OFFERS } from '@/content'
import { Icon } from '@/icons'
import { LINKS } from '@/lib/links'

/**
 * The "Your business, on Blooq" dialog. Shown once per browser session, a
 * second after the page opens, and never again once dismissed — see App.
 */
export function ListBusinessDialog({ onClose }: { onClose: () => void }) {
  const cta = useRef<HTMLAnchorElement>(null)

  useEffect(() => {
    cta.current?.focus()
    const previous = document.body.style.overflow
    document.body.style.overflow = 'hidden'
    const onKey = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose()
    }
    addEventListener('keydown', onKey)
    return () => {
      document.body.style.overflow = previous
      removeEventListener('keydown', onKey)
    }
  }, [onClose])

  return (
    <div className="mo" onClick={(event) => event.target === event.currentTarget && onClose()}>
      <div className="md" role="dialog" aria-modal="true" aria-labelledby="md-title">
        <button className="x" aria-label="Close" onClick={onClose}>
          <Icon name="x" size={18} />
        </button>
        <div className="md-l">
          <span className="tag" style={{ alignSelf: 'flex-start' }}>
            Free to start · no card needed
          </span>
          <h2 id="md-title">Your business, on Blooq.</h2>
          <p>Be found by customers searching near you, and run everything from one place. Live in about a minute.</p>
          <img src="/mascot.webp" alt="" />
        </div>
        <div className="md-r">
          <p className="mute" style={{ fontWeight: 700, marginBottom: 12 }}>
            What you get
          </p>
          <ul>
            {OFFERS.map(([icon, title, text]) => (
              <li key={title}>
                <span>
                  <Icon name={icon} size={18} />
                </span>
                <div>
                  <strong>{title}</strong>
                  <small>{text}</small>
                </div>
              </li>
            ))}
          </ul>
          <div className="md-a">
            <a ref={cta} className="btn g lg" href={LINKS.signup}>
              List your business — Free
            </a>
            <a className="btn ghost" href="#business" onClick={onClose}>
              See what is included
            </a>
          </div>
          <button className="mute md-later" onClick={onClose}>
            Maybe later
          </button>
        </div>
      </div>
    </div>
  )
}
